import React, { Component } from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';

import './InstallationRequestList.scss';
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import moment from "moment/moment";
import ModalLoading from "../../../components/common/ModalLoading";
import {
  Badge,
  Button,
  ButtonGroup,
  FormInput,
  FormSelect,
  FormTextarea,
  Modal,
  ModalBody,
  ModalHeader
} from "shards-react";
import { toast } from "react-toastify";
import { reactLocalStorage as Storage } from "reactjs-localstorage";

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ board }) => ({getBoardList: board.getBoardList, updateBoard: board.updateBoard, removeBoard: board.removeBoard}))
@inject(({ AOA }) => ({ csLogin: AOA.csLogin, getBoardMailPreview: AOA.getBoardMailPreview }))

@observer
class InstallationRequestList extends Component {

  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {};
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  @observable storageCfg = {
    is: true
  };

  @observable listParams = {
    page: 1,
    limit: 100,
    displayStatus: 100,
    searchParams: {
      status: 'all',
      boardName: 'installationRequest'
    }
  };
  @observable list = {};
  @observable searchFormValue = {
    status: 'all',
    keyword: ''
  };

  @observable modals = {
    isDetail: false,
    detailData: {},
    isMailGuide: false,
    isRejectFlow: false,  // 진행보류 흐름 — 답변 필수 입력 강제
  };

  // 메일 미리보기 — 실제 백엔드 buildBoardMailContent HTML
  @observable mailPreview = {
    loading: false,
    html: '',
    subject: '',
    recipients: [],
    scenario: 'in_progress'
  };
  MAIL_SCENARIOS = [
    { key: 'new',          label: '신규 등록 (요청 접수)', status: 'in_progress',   isNew: true,  badge: '신규' },
    { key: 'in_progress',  label: '설치중으로 변경',         status: 'in_progress',   isNew: false, badge: '진행' },
    { key: 'install_end',  label: '설치완료로 변경',         status: 'install_end',   isNew: false, badge: '완료' },
    { key: 'rejected',     label: '진행보류로 변경',         status: 'rejected',      isNew: false, badge: '보류' },
    { key: 'comment_save', label: '답변 저장 시',           status: 'comment_save',  isNew: false, badge: '답변' }
    // 삭제 시 메일 발송은 의도적으로 비활성화 (boardMutation.removeBoard) — 미리보기 시나리오에서 제외
  ];

  fetchMailPreview = (scenarioKey) => {
    const sc = this.MAIL_SCENARIOS.find(s => s.key === scenarioKey) || this.MAIL_SCENARIOS[1];
    this.mailPreview.loading = true;
    this.mailPreview.scenario = sc.key;
    this.props.getBoardMailPreview({
      boardName: 'installationRequest',
      status: sc.status,
      isNew: sc.isNew
    }, (res) => {
      const data = (res && res.data) || {};
      this.mailPreview.loading = false;
      this.mailPreview.html = data.html || '<p style="padding:24px;color:#9CA3AF;">미리보기를 가져오지 못했습니다.</p>';
      this.mailPreview.subject = data.subject || '';
      this.mailPreview.recipients = Array.isArray(data.recipients) ? data.recipients : [];
    });
  };

  openMailGuide = () => {
    this.modals.isMailGuide = true;
    this.fetchMailPreview(this.mailPreview.scenario || 'in_progress');
  };

  constructor(props) {
    super(props);
    this.init();
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
  }

  @action
  init = async (key) => {
    if (this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store;
      this.listParams.store_id = this.store._id;

      let storageCfg = await Storage.getObject('storageCfg');
      if (storageCfg.is) {
        this.storageCfg = storageCfg;
      }

      this.permissions = this.props.me.permissions;
      if (this.teamUser.isSuper && this.listParams.store_id) {
        this.urlParamsToListParams();
      }
    }
    else {
      if (Storage.get('token')) {
      }
    }
  };

  @action
  getList = async () => {
    Storage.set('limitInstallationRequestList', this.listParams.limit);
    if (this.listParams.store_id) {
      this.list = await this.props.getBoardList(this.listParams);
      console.log(this.list.docs[0]);
      this.isLoading = false;
    }
    else {
      this.isLoading = false;
    }
  };

  urlParamsToListParams = function () {
    let searchFormValueArr = {};
    for (const key of this.urlParams.keys()) {
      if (['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
        this.listParams[key] = parseInt(this.urlParams.get(key));
      }
      else {
        if (key.indexOf('__') > -1) {
          let keyArr = key.split('__');
          if (!searchFormValueArr[keyArr[0]]) { searchFormValueArr[keyArr[0]] = {}; }
          searchFormValueArr[keyArr[0]][keyArr[1]] = true;
        }
        else {
          if (this.urlParams.get(key) === "true") {
            this.searchFormValue[key] = true;
            this.listParams.searchParams[key] = true;
          }
          else if (this.urlParams.get(key) === "false") {
            this.searchFormValue[key] = false;
            this.listParams.searchParams[key] = false;
          }
          else {
            this.searchFormValue[key] = this.urlParams.get(key);
            this.listParams.searchParams[key] = this.urlParams.get(key);
          }
        }
      }
    }

    for (let key in searchFormValueArr) {
      if (searchFormValueArr[key].all) {
        for (let deKey in this.searchFormValue[key]) {
          this.searchFormValue[key][deKey] = true;
        }
      }
      else {
        for (let deKey in this.searchFormValue[key]) {
          if (searchFormValueArr[key][deKey]) {
            this.searchFormValue[key][deKey] = true;
          }
          else {
            this.searchFormValue[key][deKey] = false;
          }
        }
      }
      this.listParams.searchParams[key] = searchFormValueArr[key];
    }

    this.getList();
  };

  onChangeValue = async (event) => {
    const { name, value } = event.target;
    this.teamUser[name] = value;
  };

  onChangeSearchValue = async (event, obj) => {
    const { name, value, type } = event.target;
    let newValue;
    if (type === 'checkbox') {
      if (value) {
        newValue = !JSON.parse(value);
      }
      else {
        newValue = true;
      }
    }
    else {
      newValue = value;
    }

    if (obj) {
      obj[name] = newValue;
    }
    else {
      this.searchFormValue[name] = newValue;
    }

    if (name === "sort") {
      this.listParams.sort = newValue;
      this.getList();
    }
  };

  modalToggle = function (target, data) {
    let _this = this;
    if (!target) {
      for (var i in _this.modals) {
        if (i.indexOf('is') === 0) {
          _this.modals[i] = false;
        }
      }
    }
    else {
      _this.modals[target] = !this.modals[target];
    }
    // 상세 모달을 일반 진입 경로로 여는 경우 진행보류 흐름 플래그 초기화
    if (target === 'isDetail' && _this.modals[target]) {
      _this.modals.isRejectFlow = false;
    }

    if (data) {
      if (target === 'isDetail' && data) {
        _this.modals.detailData = data;
      }
      else {
        _this.modals.data = data;
      }
    }
  };

  updateBoard = async (item, status) => {
    // 진행보류는 답변 필수 — 즉시 처리 대신 상세 모달 열어 답변 입력 받음
    if (status === 'rejected') {
      this.openRejectFlow(item);
      return;
    }
    let params = {
      id: item._id,
      store_id: item.store_id._id,
      shopNo: item.shopNo,
      boardName: item.boardName,
      status: status,
      notifyAuthor: true
    };
    console.log(params);
    let res = await this.props.updateBoard(params);
    if (res.errors && res.errors.length > 0) {
      toast(res.errors[0].message);
    } else {
      toast('상태가 업데이트되었습니다.');
      this.getList();
    }
  };

  // === 진행보류 흐름: 상세 모달 오픈 → 답변 필수 입력 → 저장 시 status=rejected + comment 동시 update
  openRejectFlow = (item) => {
    // 모달 진입 시 답변이 비어 있어도 입력 텍스트영역은 노출되어야 함 — comment 초기화 (이전 값 유지)
    this.modals.detailData = item;
    this.modals.isDetail = true;
    this.modals.isRejectFlow = true;
  };

  confirmReject = async () => {
    const item = this.modals.detailData;
    const comment = (item && item.comment ? String(item.comment) : '').trim();
    if (!comment) {
      alert('진행보류 사유(답변)를 입력해 주세요.');
      return;
    }
    if (!window.confirm('진행보류로 처리합니다. 입력한 답변과 함께 작성자에게 메일이 발송됩니다. 계속하시겠어요?')) return;

    let params = {
      id: item._id,
      store_id: item.store_id._id,
      shopNo: item.shopNo,
      boardName: item.boardName,
      status: 'rejected',
      comment: comment,
      notifyAuthor: true
    };
    let res = await this.props.updateBoard(params);
    if (res.errors && res.errors.length > 0) {
      toast(res.errors[0].message);
    } else {
      toast('진행보류로 처리되었습니다.');
      this.modals.isDetail = false;
      this.modals.isRejectFlow = false;
      this.getList();
    }
  };

  closeDetailModal = () => {
    this.modals.isDetail = false;
    this.modals.isRejectFlow = false;
  };

  updateComment = async (item) => {
    let params = {
      id: item._id,
      store_id: item.store_id._id,
      shopNo: item.shopNo,
      boardName: item.boardName,
      comment: item.comment,
      notifyAuthor: true
    };
    console.log(params);
    let res = await this.props.updateBoard(params);
    if (res.errors && res.errors.length > 0) {
      toast(res.errors[0].message);
    } else {
      toast('답변이 저장되었습니다.');
      this.getList();
    }
  };

  updateModalComment = async () => {
    await this.updateComment(this.modals.detailData);
  };

  deleteRequest = async (item) => {
    if (window.confirm('정말로 이 설치 신청을 삭제하시겠습니까?')) {
      let params = {
        id: item._id
      };
      let res = await this.props.removeBoard(params);
      if (res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      } else {
        toast('설치 신청이 삭제되었습니다.');
        this.getList();
      }
    }
  };

  csLogin = async (item) => {
    let params = {
      id: item.store_id._id,
      platformId: item.store_id.platformId,
      emailId: item.store_id.email
    }
    console.log(params)
    await this.props.csLogin(params);
    await Storage.remove("shops");
    window.location.href = "/reviewList";
  };

  onChangeModalInputs = async (event, targetObj) => {
    let { name, value } = event.target;
    targetObj[name] = value;
  };

  render() {
    let _this = this;

    function Pagination() {
      let result = [];
      let totalPages = _this.list.totalPages;
      let curPageNum = _this.list.page;
      let startNum = (parseInt((curPageNum - 1) / 10) * 10) + 1;
      let endNum = startNum + 9 < totalPages ? startNum + 9 : totalPages;

      let urlParamsArr = new URLSearchParams(window.location.search);
      urlParamsArr.delete('page');
      let urlParams = '?' + urlParamsArr.toString();

      let rendering = () => {
        for (let i = startNum; i <= endNum; i++) {
          if (i === curPageNum) {
            result.push(<li key={i} className="on"><a href={urlParams + "&page=" + i}>{i}</a></li>);
          }
          else {
            result.push(<li key={i}><a href={urlParams + "&page=" + i}>{i}</a></li>);
          }
        }
        return result;
      };

      if (_this.list && _this.list.totalPages) {
        return (
            <div className="pagination">
              <ul>
                {curPageNum !== 1 ? <li className="btn-page-first"><a href={urlParams + "&page=1"}><FeatherIcon icon="chevrons-left" className="nd-icon" /></a></li> : null}
                {startNum - 1 > 0 ? <li className="btn-page-prev"><a href={urlParams + "&page=" + (startNum - 1)}><FeatherIcon icon="chevron-left" className="nd-icon" /></a></li> : null}
                {rendering()}
                {endNum !== totalPages ? <li className="btn-page-next"><a href={urlParams + "&page=" + (startNum + 10)}><FeatherIcon icon="chevron-right" className="nd-icon" /></a></li> : null}
                {curPageNum !== totalPages ? <li className="btn-page-last"><a href={urlParams + "&page=" + totalPages}><FeatherIcon icon="chevrons-right" className="nd-icon" /></a></li> : null}
              </ul>
            </div>);
      }
      else {
        return (<></>);
      }
    }
    function GetStatusBadge(props) {
      let statusDom = '';
      switch (props.status) {
        case "published":
          statusDom = <Badge theme="secondary">대기중</Badge>;
          break;
        case "in_progress":
          statusDom = <Badge theme="info">설치중</Badge>;
          break;
        case "install_end":
          statusDom = <Badge theme="success">설치완료</Badge>;
          break;
        case "rejected":
          statusDom = <Badge theme="warning">진행 보류</Badge>;
          break;
        case "completed":
          statusDom = <Badge theme="success">완료</Badge>;
          break;
        default:
          statusDom = <Badge outline theme="info">{props.status}</Badge>;
          break;
      }
      return statusDom;
    }

    return (
        <div className="main-content">
          <PageTitle />
          <div className="user-list-box">
            <div className="section-box">
              <form id="" target="" className="">
                <div className="user-search-box">
                  <table>
                    <tbody>
                    <tr>
                      <th>검색어</th>
                      <td>
                        <div className="search-input-box">
                          <input type="text" name="keyword" className="table-input-text search-input"
                                 value={this.searchFormValue.keyword}
                                 onChange={event => this.onChangeSearchValue(event)} />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>상태</th>
                      <td>
                        <label className="">
                          <input type="checkbox" name="pending" onChange={event => {
                            this.onChangeSearchValue(event)
                          }} value={this.searchFormValue.pending}
                                 checked={Boolean(this.searchFormValue.pending)} />
                          <span>대기중</span>
                        </label>

                        <label className="ml-5">
                          <input type="checkbox" name="approved" onChange={event => {
                            this.onChangeSearchValue(event)
                          }} value={this.searchFormValue.approved}
                                 checked={Boolean(this.searchFormValue.approved)} />
                          <span>승인</span>
                        </label>

                        <label className="ml-5">
                          <input type="checkbox" name="rejected" onChange={event => {
                            this.onChangeSearchValue(event)
                          }} value={this.searchFormValue.rejected}
                                 checked={Boolean(this.searchFormValue.rejected)} />
                          <span>반려</span>
                        </label>

                        <label className="ml-5">
                          <input type="checkbox" name="completed" onChange={event => {
                            this.onChangeSearchValue(event)
                          }} value={this.searchFormValue.completed}
                                 checked={Boolean(this.searchFormValue.completed)} />
                          <span>완료</span>
                        </label>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div className="btn-search">
                    <input type="submit" value="검색" className="search-button" />
                  </div>
                </div>
              </form>
            </div>

            <div className="section-box">
              <form id="" target="" className="">
                <div className="user-list-table">
                  <div className="user-pick-list">
                    <div className="pick-list-count">
                      검색결과 <span>{this.list.totalDocs}</span>개
                    </div>
                    <div className="choice-num-view" style={{display: 'flex', alignItems: 'center', gap: 8}}>
                      <Button size="sm" theme="light" type="button"
                              onClick={() => this.openMailGuide()}
                              style={{display: 'inline-flex', alignItems: 'center', gap: 4}}>
                        <FeatherIcon icon="mail" size="13"/> 메일 안내 샘플
                      </Button>
                      <select name="limit"
                              value={this.listParams.limit}
                              onChange={event => {
                                this.listParams.limit = parseInt(event.target.value);
                                this.onChangeSearchValue(event, this.listParams);
                              }}
                              className="">
                        <option value="50">50개씩 보기</option>
                        <option value="100">100개씩 보기</option>
                        <option value="200">200개씩 보기</option>
                        <option value="20">20개씩 보기</option>
                      </select>
                      <select name="sort"
                              value={this.listParams.sort}
                              onChange={event => {
                                this.listParams.sort = event.target.value;
                                this.onChangeSearchValue(event, this.listParams);
                              }}
                              className="">
                        <option value="createdAt">신청일순</option>
                        <option value="updatedAt">수정일순</option>
                        <option value="company">회사명순</option>
                      </select>
                    </div>
                  </div>
                  <table className="store-list">
                    <colgroup>
                      <col width="10%" />
                      <col width="10%" />
                      <col width="15%" />
                      <col width="5%" />
                      <col width="5%" />
                      <col width="5%" />
                      <col width="" />
                    </colgroup>
                    <thead>
                    <tr>
                      <th>스토어</th>
                      <th>담당자</th>
                      <th>연락처/이메일</th>
                      <th>상태</th>
                      <th>신청일</th>
                      <th>로그인</th>
                      <th>관리</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.list && this.list.docs && this.list.docs.length > 0 ?
                        this.list.docs.map((item, i) => (
                            <tr key={i}>
                              <td onClick={e => this.modalToggle('isDetail', item)}>{item.store_id.name}</td>
                              <td>{item.authorName}</td>
                              <td>{item.contact}({item.email})</td>
                              <td className="text-center">
                                <GetStatusBadge status={item.status} />
                              </td>
                              <td>{moment(item.createdAt).format('YYYY.MM.DD')}</td>
                              <td className="text-center">
                                <Button size="sm" theme="info" onClick={e => this.csLogin(item)}>로그인</Button>
                              </td>
                              <td>
                                <div style={{display: 'flex', gap: '5px', alignItems: 'center', flexWrap: 'wrap'}}>
                                  <ButtonGroup>
                                    <Button size="sm" theme="primary" onClick={e => this.updateBoard(item, 'in_progress')}>설치중</Button>
                                    <Button size="sm" theme="success" onClick={e => this.updateBoard(item, 'install_end')}>설치완료</Button>
                                    <Button size="sm" theme="warning" onClick={e => this.updateBoard(item, 'rejected')}>진행 보류</Button>
                                    <Button size="sm" theme="danger" onClick={e => this.deleteRequest(item)}>삭제</Button>
                                  </ButtonGroup>
                                  {item.comment ? (
                                    <FormInput
                                        name="comment"
                                        placeholder="답변"
                                        onChange={event => {
                                          this.onChangeModalInputs(event, item)
                                        }}
                                        value={item.comment}
                                        size="sm"
                                        style={{minWidth: '150px', flex: '1'}}
                                    />
                                  ) : (
                                    <FormSelect
                                        name="predefinedReply"
                                        size="sm"
                                        onChange={event => {
                                          const selectedReply = event.target.value;
                                          if (selectedReply) {
                                            item.comment = selectedReply;
                                          }
                                        }}
                                        style={{minWidth: '150px', flex: '1'}}
                                    >
                                      <option value="">답변 선택</option>
                                      <option value="설치가 완료되었습니다. 이용해주셔서 감사합니다.">설치 완료</option>
                                      <option value="설치 진행 중입니다. 완료까지 1-2일 소요될 예정입니다.">설치 진행 중</option>
                                      <option value="추가 정보가 필요합니다. 담당자가 별도 연락드리겠습니다.">추가 정보 필요</option>
                                      <option value="기술적 검토가 필요합니다. 검토 후 다시 연락드리겠습니다.">기술 검토 필요</option>
                                      <option value="현재 서비스 점검으로 인해 설치가 지연되고 있습니다.">서비스 점검 지연</option>
                                      <option value="요청해주신 내용으로는 설치가 어렵습니다.">설치 불가</option>
                                    </FormSelect>
                                  )}
                                  <Button size="sm" theme="secondary" onClick={e => {
                                    this.updateComment(item)
                                  }}>
                                    저장
                                  </Button>
                                  <Button size="sm" onClick={e => this.modalToggle('isDetail', item)}>상세</Button>
                                </div>
                              </td>
                            </tr>))
                        :
                        <tr>
                          <td colSpan={9} className="text-center">설치 신청 내역이 없습니다</td>
                        </tr>
                    }
                    </tbody>
                  </table>
                  <Pagination />
                </div>
              </form>
            </div>
          </div>

          <Modal size="lg" className='modal-installation-request-detail' open={this.modals.isDetail} toggle={() => {}} centered={true}>
            <ModalHeader>설치 신청 상세</ModalHeader>
            <ModalBody className="history-window-popup">
              <div className="history-popup-contents">
                {this.modals.detailData && this.modals.detailData.store_id ? (
                    <table>
                      <colgroup>
                        <col style={{ width: '15%' }} />
                        <col style={{ width: '35%' }} />
                        <col style={{ width: '15%' }} />
                        <col style={{ width: '35%' }} />
                      </colgroup>
                      <tbody>
                      <tr>
                        <th>스토어</th>
                        <td>{this.modals.detailData.store_id.name}</td>
                        <th>담당자</th>
                        <td>{this.modals.detailData.authorName}</td>
                      </tr>
                      <tr>
                        <th>연락처</th>
                        <td>{this.modals.detailData.contact}</td>
                        <th>이메일</th>
                        <td>{this.modals.detailData.email}</td>
                      </tr>
                      <tr>
                        <th>신청 서비스</th>
                        <td>{this.modals.detailData.service}</td>
                        <th>상태</th>
                        <td><GetStatusBadge status={this.modals.detailData.status} /></td>
                      </tr>
                      <tr>
                        <th>신청일</th>
                        <td>{moment(this.modals.detailData.createdAt).format('YYYY.MM.DD HH:mm')}</td>
                        <th>처리일</th>
                        <td>{this.modals.detailData.processedAt ? moment(this.modals.detailData.processedAt).format('YYYY.MM.DD HH:mm') : '-'}</td>
                      </tr>
                      <tr>
                        <th>설치 요청 세부 내용</th>
                        <td colSpan="3">
                          <div style={{
                            padding: '10px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '4px',
                            minHeight: '60px',
                            whiteSpace: 'pre-wrap',
                            border: '1px solid #dee2e6'
                          }}>
                            {this.modals.detailData.content || '(입력된 세부 내용이 없습니다)'}
                          </div>
                        </td>
                      </tr>
                      {Array.isArray(this.modals.detailData.attachments) && this.modals.detailData.attachments.length > 0 && (
                        <tr>
                          <th>첨부 파일</th>
                          <td colSpan="3">
                            <div style={{display: 'flex', flexWrap: 'wrap', gap: 8}}>
                              {this.modals.detailData.attachments.map((file, idx) => {
                                const filename = (file && file.meta && file.meta.filename) || (file && file.url ? file.url.split('/').pop() : `첨부 ${idx + 1}`);
                                const isImage = file && file.type === 'image' && file.url;
                                if (isImage) {
                                  return (
                                    <a key={idx} href={file.url} target="_blank" rel="noopener noreferrer" title={filename}>
                                      <img src={file.url} alt={filename}
                                           style={{width: 80, height: 80, objectFit: 'cover', borderRadius: 4, border: '1px solid #dee2e6'}}/>
                                    </a>
                                  );
                                }
                                return (
                                  <a key={idx}
                                     href={file && file.url ? file.url : '#'}
                                     target="_blank"
                                     rel="noopener noreferrer"
                                     onClick={e => { if (!file || !file.url) e.preventDefault(); }}
                                     style={{
                                       display: 'inline-flex', alignItems: 'center', gap: 6,
                                       padding: '6px 10px', border: '1px solid #dee2e6', borderRadius: 4,
                                       background: '#f8f9fa', fontSize: 13, color: '#3D5170',
                                       textDecoration: 'none', maxWidth: 280
                                     }}
                                     title={filename}>
                                    <FeatherIcon icon="paperclip" size="13" style={{flexShrink: 0}}/>
                                    <span style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{filename}</span>
                                  </a>
                                );
                              })}
                            </div>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <th>답변</th>
                        <td colSpan="3">
                          <div style={{marginBottom: '10px'}}>
                            <FormSelect
                                name="predefinedReply"
                                value=""
                                onChange={event => {
                                  const selectedReply = event.target.value;
                                  if (selectedReply) {
                                    this.modals.detailData.comment = selectedReply;
                                  }
                                }}
                                style={{width: '100%', marginBottom: '10px'}}
                            >
                              <option value="">미리 정해진 답변 선택</option>
                              <option value="계정확인 완료하였습니다.">계정확인</option>
                            </FormSelect>
                          </div>
                          <FormTextarea
                              name="comment"
                              placeholder="답변을 입력하세요"
                              onChange={event => this.onChangeModalInputs(event, this.modals.detailData)}
                              value={this.modals.detailData.comment || ''}
                              rows={4}
                              style={{width: '100%', padding: '8px'}}
                          />
                        </td>
                      </tr>
                      </tbody>
                    </table>) : null}

                {/* 진행보류 흐름 안내 */}
                {this.modals.isRejectFlow && (
                  <div style={{
                    margin: '10px 0',
                    padding: '12px 14px',
                    background: '#FEF3C7',
                    border: '1px solid #FDE68A',
                    borderRadius: 8,
                    color: '#92400E',
                    fontSize: 13,
                    lineHeight: 1.6
                  }}>
                    <strong>진행보류 처리</strong> — 작성자에게 발송될 답변(보류 사유)을 위 텍스트 영역에 입력한 뒤 <strong>[진행보류로 처리]</strong> 버튼을 눌러주세요. 답변이 비어 있으면 처리할 수 없습니다.
                  </div>
                )}

                <div className="text-center mt-2">
                  <ButtonGroup>
                    {this.modals.isRejectFlow ? (
                      <Button theme="warning"
                              disabled={!(this.modals.detailData && (this.modals.detailData.comment || '').toString().trim())}
                              onClick={() => this.confirmReject()}>
                        <FeatherIcon icon="pause-circle" size="14"/> 진행보류로 처리
                      </Button>
                    ) : (
                      <Button theme="primary" onClick={e => this.updateModalComment()}>저장</Button>
                    )}
                    <Button theme="light" onClick={() => this.closeDetailModal()}>닫기</Button>
                  </ButtonGroup>
                </div>
              </div>
            </ModalBody>
          </Modal>

          {/* 메일 안내 미리보기 — 백엔드 buildBoardMailContent HTML 실시간 fetch */}
          <Modal size="lg" className='modal-mail-guide' open={this.modals.isMailGuide} toggle={() => { this.modals.isMailGuide = false; }} centered={true}>
            <ModalHeader toggle={() => { this.modals.isMailGuide = false; }}>설치 안내 메일 미리보기</ModalHeader>
            <ModalBody>
              {/* 시나리오 선택 */}
              <div style={{display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 14}}>
                {this.MAIL_SCENARIOS.map(sc => (
                  <button
                    key={sc.key}
                    type="button"
                    onClick={() => this.fetchMailPreview(sc.key)}
                    style={{
                      padding: '6px 12px',
                      borderRadius: 100,
                      border: '1px solid ' + (this.mailPreview.scenario === sc.key ? '#6D28D9' : '#E5E7EB'),
                      background: this.mailPreview.scenario === sc.key ? '#6D28D9' : '#FFFFFF',
                      color: this.mailPreview.scenario === sc.key ? '#FFFFFF' : '#4B5563',
                      fontSize: 12,
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    {sc.label}
                  </button>
                ))}
              </div>

              {/* 메타 영역 */}
              <div style={{
                background: '#F9FAFB',
                border: '1px solid #E5E7EB',
                borderRadius: 8,
                padding: 14,
                marginBottom: 14,
                fontSize: 12,
                color: '#4B5563',
                lineHeight: 1.6
              }}>
                <div><strong>발신</strong>: noreply (백엔드 fromMailAddress)</div>
                <div>
                  <strong>수신</strong>:&nbsp;
                  {(this.mailPreview.recipients && this.mailPreview.recipients.length > 0)
                    ? this.mailPreview.recipients.join(', ')
                    : (this.mailPreview.loading ? '확인 중...' : '-')}
                </div>
                <div><strong>제목</strong>: <span style={{color: '#1F2937', fontWeight: 600}}>{this.mailPreview.subject || '로딩 중...'}</span></div>
                <div style={{fontSize: 11, color: '#9CA3AF', marginTop: 4}}>※ 실제 발송되는 HTML 을 백엔드(<code>buildBoardMailContent</code>)에서 그대로 가져온 미리보기입니다.</div>
              </div>

              {/* HTML iframe */}
              <div style={{
                border: '1px solid #E5E7EB',
                borderRadius: 8,
                overflow: 'hidden',
                background: '#FFFFFF',
                minHeight: 500,
                position: 'relative'
              }}>
                {this.mailPreview.loading ? (
                  <div style={{padding: 60, textAlign: 'center', color: '#9CA3AF'}}>불러오는 중...</div>
                ) : (
                  <iframe
                    title="메일 미리보기"
                    srcDoc={this.mailPreview.html}
                    style={{width: '100%', height: 600, border: 'none', display: 'block'}}
                    sandbox=""
                  />
                )}
              </div>

              <div className="text-center mt-3">
                <Button theme="light" onClick={() => { this.modals.isMailGuide = false; }}>닫기</Button>
              </div>
            </ModalBody>
          </Modal>

          <ModalLoading isLoading={this.isLoading} />
        </div>
    )
  }
}

export default InstallationRequestList;
